
import { config } from '../core';
import matchMedia from '../helpers/matchMedia';

export default class Problem {
  constructor() {
    this.problem = document.querySelector('[data-problem]');
    if (!this.problem) return;
    this.balloons = [...document.querySelectorAll('[data-balloon]')]
    this.array = [];
    for (let i = 1; i <= this.balloons.length; i++) {
      this.array.push(document.querySelector(`[data-balloon-num-pc="${i}"]`));
    }
    this.init();
  }
  
  init() {
    this.setup();
    this.animate();
  }

  setup() {
    gsap.set(this.balloons, { autoAlpha: 0, yPercent: 50 })
  }

  animate() {
    matchMedia(config.breakPoint.pc, (matches) => {
      if (matches) {
        gsap.to(this.array, {
          autoAlpha: 1,
          yPercent: 0,
          stagger: {
            each: 0.15,
          },
          scrollTrigger: {
            trigger: this.problem,
            start: 'top 80%',
          },
          duration: 1.0,
          ease: 'circ.out',
        })
      } else {
        this.balloons.forEach(balloon => {
          gsap.to(balloon, {
            autoAlpha: 1,
            yPercent: 0,
            scrollTrigger: {
              trigger: balloon,
              start: 'top 80%',
            },
            duration: 1.0,
            ease: 'circ.out',
          })
        });
      }
    })
  }
}
